import { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

const FunctionalButtonsLine = ({ functionalControlled, onButtonClick }) => {
  const [clickedKey, setClickedKey] = useState('');
  const { t } = useTranslation();
  const functionalButtons = [
    { key: 'greater', text: t('LotteryBlock.functionalButton_greater'), func: value => value > 4 },
    { key: 'less', text: t('LotteryBlock.functionalButton_less'), func: value => value < 5 },
    { key: 'odd', text: t('LotteryBlock.functionalButton_odd'), func: value => value % 2 !== 0 },
    { key: 'even', text: t('LotteryBlock.functionalButton_even'), func: value => value % 2 === 0 },
    { key: 'all', text: t('LotteryBlock.functionalButton_all'), func: () => true },
  ];
  const handleButtonClick = (key, func) => {
    setClickedKey(key);

    onButtonClick?.(func);
  };

  useEffect(() => {
    if (!functionalControlled) {
      setClickedKey('');
    }
  }, [functionalControlled]);

  return (
    <div className="functionalButtonsLine">
      {functionalButtons.map(({ key, text, func }) => {
        const classNames = classnames('functionalButton', {
          active: key === clickedKey,
        });

        return (
          <button key={key} className={classNames} onClick={() => handleButtonClick(key, func)}>
            {text}
          </button>
        );
      })}
    </div>
  );
};

export default FunctionalButtonsLine;
